<template>
  <div class="row">
    <div class="col-sm footer-left-side">
      <p>Términos y Condiciones del sitio</p>
    </div>
    <div class="col-sm footer-right-side">
      <button class="footer-next-btn">siguiente: {{ nextStep }}</button>
       <img src="@images/ccb.png">
    </div>    
  </div>
</template>
<script type="text/javascript">
  export default{
    name:'Footer',
    props: {
      nextStep:{
        type: String,
        required: true
      }
    },
    data(){
      return{
        
      }
    }
  }
</script>
<style type="text/css">
.footer-right-side{
  display: flex;
  flex-flow: column;
  align-items: flex-end;
  margin-right: 7%;

}

.footer-right-side > button, .footer-right-side > img{
  width: 30%;
}

.footer-right-side > button{
    background-color: black;
    color: white;
    font-weight: bold;
    text-transform: capitalize;
    font-size: 0.7em;
    border-radius: 5px;
    border-style: none;
    padding: 7px 0px;
    margin-bottom: 5%;
}
.footer-left-side > p{
    position: absolute;
    font-size: 0.6em;
    bottom: 10vh;
    padding-left: 10vw;
}

.footer-right-side > button:hover{
  background-color: white;
  color: black;
  border: 1px solid black;
}
</style>